import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    currentList: [],
    totalButton: ''
  },
  mutations: {
    setCurrentData(state, payload) {
      state.currentList = payload.list.slice();
      state.totalButton = payload.masterButton;
    }
  },
  actions: {
    getLists({ commit }, data) {
      api.getList(data).then(res => {
        commit('setCurrentData', res.data);
      });
    },
    setOneSwitchs(context, { type, pair, button }) {
      return api.setOneSwitch(type, pair, button);
    },
    setTotalSwitchs(context, data) {
      return api.setTotalSwitch(data);
    },
    setBargains(context, { content, type }) {
      return api.setBargain(content, type);
    }
  }
};

appStore.registerModule('robotSetting', store);
